import { createContext, Dispatch, SetStateAction, useContext } from 'react';
import type { ExtractedTargetInfo } from '@ais-ui/websockets';

export interface SelectionStateContextProps {
  targetInfoDetailsList: ExtractedTargetInfo[];
  setTargetInfoDetailsList: Dispatch<SetStateAction<ExtractedTargetInfo[]>>;
  [key: string]: unknown;
}

export const SelectionStateContext = createContext<
  SelectionStateContextProps | undefined
>(undefined);

export function useSelectionState<
  T extends SelectionStateContextProps = SelectionStateContextProps,
>(): T {
  const context = useContext(SelectionStateContext);
  if (!context) {
    throw new Error(
      'useSelectionState must be used within a SelectionStateProvider',
    );
  }
  return context as T;
}
